import { EntryKinds, isTableEntry } from '@i-ark/models';
import { selectPageEntryById } from './entry.page-by-id.js';

const selectTableCellEntryById = (pageId, itemId, cellId) => data => {
  const page = selectPageEntryById(pageId)(data);
  const item = {
    entry: page.items[itemId]?.entry ?? {
      kind: EntryKinds.TABLE,
      cells: {}
    }
  };
  if (!isTableEntry(item.entry)) {
    throw new Error("selectTableEntryById(): Entry is not of type input");
  }
  return item.entry.cells[cellId];
};

export { selectTableCellEntryById };
//# sourceMappingURL=entry.table-cell-by-id.js.map
